import GigCards from './mp_gig_card';
import ListViewCard from './list_view_card';

window.ListViewCard = ListViewCard;
window.BuyerGigCard = GigCards;



// WEBPACK FOOTER //
// ./src/port.js